function getRandomNumberInRange(minValue, maxValue) {
    if (minValue > maxValue) {
        throw new Error("minValue should be less than or equal to maxValue");
    }

    // Create a Uint32Array (4 bytes = 32 bits)
    const randomArray = new Uint32Array(1);
    
    // Fill the array with a cryptographically secure random number
    crypto.getRandomValues(randomArray);

    // Map the random value to the desired range [minValue, maxValue]
    const range = maxValue - minValue + 1; // +1 to make maxValue inclusive
    return minValue + (randomArray[0] % range);
}


export default getRandomNumberInRange;